import React, { useState, useEffect } from 'react'
import { Layout } from './Layout'
import axios from 'axios'
import { useLocation, useNavigate } from 'react-router-dom'
import SearchInput from '../../../components/input/SearchInput'
import Table from '../../../components/table/Table'
import DateFormatConverter from '../../../components/input/DateFormatConvert'
import { Button } from '../../../components/button/button'
import { BACKEND_URL, E_immatriculation } from '../../../constants/constant'

function PriseCharge() {
  const navigate = useNavigate()
  const location = useLocation()
  
  // États
  const [selectedRowIndex, setSelectedRowIndex] = useState(null)
  const [selectedData, setSelectedData] = useState(null)
  const [clients, setClients] = useState([])
  const [priseEnCharge, setPriseEnCharge] = useState([])
  const [searchTerm, setSearchTerm] = useState("")
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  // Récupération des données
  const fetchData = async () => {
    setIsLoading(true)
    try {
      const [clientsResponse, priseEnChargeResponse] = await Promise.all([
        axios.get(`${E_immatriculation}/contribuable`),
        axios.get(`${BACKEND_URL}/prisecharge`)
      ])
      
      setClients(clientsResponse.data)
      setPriseEnCharge(priseEnChargeResponse.data)
      setError(null)
    } catch (err) {
      setError(`Erreur lors de la récupération des données: ${err.message}`)
      console.error('Erreur:', err)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  // Configuration du tableau
  const headers = [
    "Ref démandé",
    "Raison social",
    "Référence Fiscal",
    "Type",
    "Date autorisation",
    "Régime fiscal",
    "Forme juridique",
    "Date de création",
    "RIB"
  ]

  // Filtrage des données
  const filteredData = clients
    .filter(client => 
      client.id?.toLowerCase().includes(searchTerm.toLowerCase()) &&
      !priseEnCharge.some(pec => pec.id_contribuable === client.id) && client.valide === true && client.bloque === false && client.deces === false && client.radie === false && client.cessation === false 
    )
    .map(client => ([
      client.id,
      client.raison_social,
      client.reference_fiscal,
      client.type,
      <DateFormatConverter key={`date-${client.id}`} isoDate={client.date_agrement} />,
      client.regime_fiscal,
      client.forme_juridique,
      <DateFormatConverter key={`creation-${client.id}`} isoDate={client.date_creation} />,
      client.rib
    ]))

  const tableData = filteredData.length > 0 
    ? filteredData 
    : [Array(9).fill("Aucune")]

  // Gestionnaires d'événements
  const handleSearch = (e) => {
    setSearchTerm(e.target.value)
  }

  const handleRowSelect = (rowIndex) => {
    const newIndex = selectedRowIndex === rowIndex ? null : rowIndex
    setSelectedRowIndex(newIndex)
    setSelectedData(newIndex !== null ? filteredData[rowIndex] : null)
  }
  

  const handleContinue = () => {
    if (!selectedData) {
      alert("Veuillez sélectionner un contribuable")
      return
    }
  
    const fullSelectedData = clients.find(client => client.id === selectedData[0])
    if (!fullSelectedData) {
      alert("Données du contribuable introuvables")
      return
    }
  
    localStorage.setItem("selectedDataPriseEnCharge", JSON.stringify(fullSelectedData))
    navigate("/SituationGeographiqueIm", { state: { selectedData: fullSelectedData } })
  }
  

  // Rendu du contenu
  const contentChildren = (
    <div className='flex justify-center items-center mt-10'>
      <div className='flex flex-col w-full max-w-[1200px]'>
        {error && (
          <div className='bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4'>
            {error}
          </div>
        )}

        <SearchInput 
          placeholder="Rechercher un contribuable" 
          onChange={handleSearch}
          disabled={isLoading}
        />

        {isLoading ? (
          <div className='text-center text-white mt-4'>Chargement...</div>
        ) : (
          <>
            <div className='mt-4 overflow-x-auto'>
              <Table 
                headers={headers} 
                data={tableData}
                onClick={handleRowSelect}
                selectedRowIndex={selectedRowIndex}
              />
            </div>

            <Button 
              className='mt-4 w-[200px] self-center'
              onClick={handleContinue}
              disabled={!selectedData}
            >
              Voir contribuable
            </Button>
          </>
        )}
      </div>
    </div>
  )

  return (
    <div className='bg-[#212122] min-h-screen'>
      <Layout currentPath={location.pathname}>
        {contentChildren}
      </Layout>
    </div>
  )
}

export default PriseCharge